export default __webpack_public_path__ + "static/media/icon-remove.40b4b5d2.svg";